import React from 'react';
import { FRESHNESS_TICK_MS } from '../../constants/RenewalPolling';

// Ticks independently of poll cadence, so the "updated Xs ago" label doesn't visibly
// freeze between polls during the slower detail-mode phase (up to 20s apart). Pass
// frozen=true once a terminal state is reached: no more updates will ever arrive, so
// counting up forever would misleadingly imply polling is still happening in the
// background.
export function useFreshnessLabel(lastUpdatedAt: number | undefined, frozen: boolean = false): string {
  // A bare re-render trigger, not real state — useReducer (rather than a useState pair
  // with a discarded value) is the idiomatic way to express "force a re-render".
  const [, forceTick] = React.useReducer((tick: number) => tick + 1, 0);

  React.useEffect(() => {
    if (lastUpdatedAt === undefined || frozen) {
      return;
    }
    const intervalId = setInterval(forceTick, FRESHNESS_TICK_MS);
    return () => clearInterval(intervalId);
  }, [lastUpdatedAt, frozen]);

  if (lastUpdatedAt === undefined) {
    return '';
  }

  const elapsedSeconds = Math.max(0, Math.round((Date.now() - lastUpdatedAt) / 1000));
  if (elapsedSeconds < 60) {
    return `updated ${elapsedSeconds}s ago`;
  }
  const elapsedMinutes = Math.round(elapsedSeconds / 60);
  return `updated ${elapsedMinutes}m ago`;
}
